module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/empty-states/no-addresses-816afe2ed574bcb182bac0286b65bef1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/empty-states/no-addresses.svg
// module id = BI1P
// module chunks = 24